var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-orientation+"},[_c('span',[_vm._v("Orientation:"+_vm._s(_vm.orientation))])])}
var staticRenderFns = []

export { render, staticRenderFns }